module.exports = __webpack_public_path__ + "img/data1-4.edfb5255.png";